import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Text } from '../../../../Text';
import { SIZES } from '../../../constants';
import styles from '@dtsl/css-input/dist/index.module.css';

// eslint-disable-next-line react/display-name
const ActionBar = /*#__PURE__*/React.memo(props => {
  const {
    id = '',
    size = SIZES.MEDIUM,
    maxCharCount = null,
    currCharCount = 0,
    actions = [],
    actionsClass = '',
    actionsStyle = {},
    stretch = false,
    disableActions
  } = props;
  const actionBarClasses = classNames({
    [styles['sib-input__actionbar']]: true,
    [styles['sib-input__actionbar--stretch']]: stretch,
    [actionsClass]: !!actionsClass
  });
  const charCountClasses = classNames({
    [styles['sib-input__charactercount']]: true
  });
  return actions && actions.length || maxCharCount ? /*#__PURE__*/React.createElement("div", {
    className: actionBarClasses,
    style: actionsStyle
  }, actions && actions.length ? /*#__PURE__*/React.createElement("div", {
    className: styles['sib-input__actions']
  }, actions.map((action, index) => /*#__PURE__*/React.cloneElement(action(), {
    key: index,
    className: styles[`sib-input__action-btn--${size}`],
    ...(disableActions ? {
      tabIndex: -1
    } : {})
  }))) : null, maxCharCount ? /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    tag: "div",
    color: "var(--sib-color_content-secondary)",
    className: charCountClasses,
    "aria-live": "polite",
    id: `${id}-charCount`,
    style: {
      marginRight: size === SIZES.SMALL ? '8px' : '12px',
      marginLeft: stretch ? '8px' : ''
    }
  }, `${currCharCount}/${maxCharCount}`) : null) : null;
});
ActionBar.propTypes = {
  maxCharCount: PropTypes.number,
  currCharCount: PropTypes.number,
  actions: PropTypes.array,
  stretch: PropTypes.bool,
  actionsClass: PropTypes.string,
  size: PropTypes.string,
  actionsStyle: PropTypes.object,
  disableActions: PropTypes.bool,
  id: PropTypes.string
};
export default ActionBar;